module.exports = __webpack_public_path__ + "img/376827.9ccb7f24.svg";